<script lang="ts">
	//Design system components
	import { Button, ButtonGroup, Radio, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Services
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import { format } from 'svelte-i18n';

	import { getContext, onDestroy } from 'svelte';
	import type { Writable } from 'svelte/store';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';

	export let device;

	//This component is for pro em for now. In near future must be abstracted for rest of emeters and to be with dynamical phases based on devices_config
	const phases = ['a', 'b'];
	const phasesTranslated = [
		$format('label_phase_a', { default: 'Phase a' }),
		$format('label_phase_b', { default: 'Phase b' }),
	];
	let phaseFrom = phases[0];
	let phaseTo = phases[1];
	let loading = false;

	const selectPhaseFrom = (phase) => {
		phaseFrom = phase;
		const index = phases.indexOf(phase);
		if (typeof phases[index + 1] !== 'undefined') {
			selectPhaseTo(phases[index + 1]);
		} else {
			selectPhaseTo(phases[index - 1]);
		}
	};
	const selectPhaseTo = (phase) => {
		phaseTo = phase;
	};

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({
				onClick: setCalibration,
				loading,
				disabled: loading,
				label: $format('button_calibrate'),
			});
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});

	const setCalibration = async () => {
		loading = true;
		const res = await gen2Request(device, 'em.phasetophasecalib', {
			id: 0,
			from: phaseFrom,
			to: phaseTo,
		});
		onSettingsResponse(res, device);
		loading = false;
	};
</script>

<Text class="mb-s" styleType="body-small"
	>{$format('calibrate_phase_from')} {$format(`label_phase_${phaseFrom}`)}</Text
>
<ButtonGroup
	id="buttongroup-tedh6jc"
	class="mb-s"
	aria-label={$format('aria_label_select_phase_from', { default: 'Select phase from' })}
>
	{#each phases as phase, i}
		<Radio
			size="m"
			class="d-inline-flex mb-s"
			bind:selected={phaseFrom}
			value={phase}
			on:click={() => selectPhaseFrom(phase)}
			id="radio-sxhbj30"
		>
			{phasesTranslated[i]}
		</Radio>
	{/each}
</ButtonGroup>
<Text class="mb-s" styleType="body-small"
	>{$format('calibrate_phase')} {$format(`label_phase_${phaseTo}`)}</Text
>
<ButtonGroup
	id="buttongroup-v967iu2"
	class="mb-s"
	aria-label={$format('aria_label_select_phase_to', { default: 'Select phase to' })}
>
	<ButtonGroup
		id="buttongroup-yl0qh6v"
		class="mb-s"
		aria-label={$format('aria_label_select_phase_to', { default: 'Select phase to' })}
	>
		{#each phases as phase, i}
			<Radio
				size="m"
				class="d-inline-flex mb-s"
				bind:selected={phaseTo}
				value={phase}
				disabled={phaseFrom === phase}
				on:click={() => selectPhaseTo(phase)}
				id="radio-6kuvb45"
			>
				{phasesTranslated[i]}
			</Radio>
		{/each}
	</ButtonGroup>
</ButtonGroup>
{#if !$showNewLayout}
	<Button size="m" {loading} width="full" on:click={setCalibration}
		>{$format('button_calibrate')}</Button
	>
{/if}
